// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/worklog.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.worklog";

export enum WorkLogType {
  WORK_LOG_TYPE_UNSPECIFIED = 0,
  RESEARCH = 1,
  PLANNING = 2,
  EXECUTION = 3,
  REVIEW = 4,
  PR = 5,
  CODING = 6,
}

export function workLogTypeFromJSON(object: any): WorkLogType {
  switch (object) {
    case 0:
    case "WORK_LOG_TYPE_UNSPECIFIED":
      return WorkLogType.WORK_LOG_TYPE_UNSPECIFIED;
    case 1:
    case "RESEARCH":
      return WorkLogType.RESEARCH;
    case 2:
    case "PLANNING":
      return WorkLogType.PLANNING;
    case 3:
    case "EXECUTION":
      return WorkLogType.EXECUTION;
    case 4:
    case "REVIEW":
      return WorkLogType.REVIEW;
    case 5:
    case "PR":
      return WorkLogType.PR;
    case 6:
    case "CODING":
      return WorkLogType.CODING;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum WorkLogType");
  }
}

export function workLogTypeToJSON(object: WorkLogType): string {
  switch (object) {
    case WorkLogType.WORK_LOG_TYPE_UNSPECIFIED:
      return "WORK_LOG_TYPE_UNSPECIFIED";
    case WorkLogType.RESEARCH:
      return "RESEARCH";
    case WorkLogType.PLANNING:
      return "PLANNING";
    case WorkLogType.EXECUTION:
      return "EXECUTION";
    case WorkLogType.REVIEW:
      return "REVIEW";
    case WorkLogType.PR:
      return "PR";
    case WorkLogType.CODING:
      return "CODING";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum WorkLogType");
  }
}

export interface WorkLogItem {
  /** server assigned */
  id: string;
  type: WorkLogType;
  /** optional, when type is unspecified */
  customType: string;
  /** optional human-readable message */
  message: string;
  /** maps to Document.id with type TASK */
  taskId?:
    | string
    | undefined;
  /** maps to Project.id */
  projectId?:
    | string
    | undefined;
  /** maps to Company.id */
  companyId?:
    | number
    | undefined;
  /** submitting user id */
  userId?:
    | string
    | undefined;
  /** client event time; server stores created_at separately */
  createdAt:
    | Date
    | undefined;
  /** Stage of the item, e.g. 'started', 'running', 'ended' */
  stage: string;
  /** Description of the action taken. */
  actionDescription: string;
  /** Optional name of the agent performing the operation. */
  agentName: string;
  /** Any extra information for the worklog. */
  extra: { [key: string]: string };
  /** True if this worklog was created via system API key (no user context). */
  system: boolean;
  /** maps to Document.id with type FEATURE */
  featureId?: string | undefined;
}

export interface WorkLogItem_ExtraEntry {
  key: string;
  value: string;
}

function createBaseWorkLogItem(): WorkLogItem {
  return {
    id: "",
    type: 0,
    customType: "",
    message: "",
    taskId: undefined,
    projectId: undefined,
    companyId: undefined,
    userId: undefined,
    createdAt: undefined,
    stage: "",
    actionDescription: "",
    agentName: "",
    extra: {},
    system: false,
    featureId: undefined,
  };
}

export const WorkLogItem: MessageFns<WorkLogItem> = {
  encode(message: WorkLogItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.customType !== "") {
      writer.uint32(26).string(message.customType);
    }
    if (message.message !== "") {
      writer.uint32(34).string(message.message);
    }
    if (message.taskId !== undefined) {
      writer.uint32(42).string(message.taskId);
    }
    if (message.projectId !== undefined) {
      writer.uint32(50).string(message.projectId);
    }
    if (message.companyId !== undefined) {
      writer.uint32(56).int32(message.companyId);
    }
    if (message.userId !== undefined) {
      writer.uint32(66).string(message.userId);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(82).fork()).join();
    }
    if (message.stage !== "") {
      writer.uint32(90).string(message.stage);
    }
    if (message.actionDescription !== "") {
      writer.uint32(98).string(message.actionDescription);
    }
    if (message.agentName !== "") {
      writer.uint32(106).string(message.agentName);
    }
    globalThis.Object.entries(message.extra).forEach(([key, value]: [string, string]) => {
      WorkLogItem_ExtraEntry.encode({ key: key as any, value }, writer.uint32(114).fork()).join();
    });
    if (message.system !== false) {
      writer.uint32(120).bool(message.system);
    }
    if (message.featureId !== undefined) {
      writer.uint32(130).string(message.featureId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkLogItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkLogItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.customType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.stage = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.actionDescription = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.agentName = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          const entry14 = WorkLogItem_ExtraEntry.decode(reader, reader.uint32());
          if (entry14.value !== undefined) {
            message.extra[entry14.key] = entry14.value;
          }
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.system = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.featureId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkLogItem {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      type: isSet(object.type) ? workLogTypeFromJSON(object.type) : 0,
      customType: isSet(object.customType)
        ? globalThis.String(object.customType)
        : isSet(object.custom_type)
        ? globalThis.String(object.custom_type)
        : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      taskId: isSet(object.taskId)
        ? globalThis.String(object.taskId)
        : isSet(object.task_id)
        ? globalThis.String(object.task_id)
        : undefined,
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : undefined,
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      stage: isSet(object.stage) ? globalThis.String(object.stage) : "",
      actionDescription: isSet(object.actionDescription)
        ? globalThis.String(object.actionDescription)
        : isSet(object.action_description)
        ? globalThis.String(object.action_description)
        : "",
      agentName: isSet(object.agentName)
        ? globalThis.String(object.agentName)
        : isSet(object.agent_name)
        ? globalThis.String(object.agent_name)
        : "",
      extra: isObject(object.extra)
        ? (globalThis.Object.entries(object.extra) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
      system: isSet(object.system) ? globalThis.Boolean(object.system) : false,
      featureId: isSet(object.featureId)
        ? globalThis.String(object.featureId)
        : isSet(object.feature_id)
        ? globalThis.String(object.feature_id)
        : undefined,
    };
  },

  toJSON(message: WorkLogItem): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.type !== 0) {
      obj.type = workLogTypeToJSON(message.type);
    }
    if (message.customType !== "") {
      obj.customType = message.customType;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.taskId !== undefined) {
      obj.taskId = message.taskId;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    if (message.companyId !== undefined) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.stage !== "") {
      obj.stage = message.stage;
    }
    if (message.actionDescription !== "") {
      obj.actionDescription = message.actionDescription;
    }
    if (message.agentName !== "") {
      obj.agentName = message.agentName;
    }
    if (message.extra) {
      const entries = globalThis.Object.entries(message.extra) as [string, string][];
      if (entries.length > 0) {
        obj.extra = {};
        entries.forEach(([k, v]) => {
          obj.extra[k] = v;
        });
      }
    }
    if (message.system !== false) {
      obj.system = message.system;
    }
    if (message.featureId !== undefined) {
      obj.featureId = message.featureId;
    }
    return obj;
  },

  create(base?: DeepPartial<WorkLogItem>): WorkLogItem {
    return WorkLogItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WorkLogItem>): WorkLogItem {
    const message = createBaseWorkLogItem();
    message.id = object.id ?? "";
    message.type = object.type ?? 0;
    message.customType = object.customType ?? "";
    message.message = object.message ?? "";
    message.taskId = object.taskId ?? undefined;
    message.projectId = object.projectId ?? undefined;
    message.companyId = object.companyId ?? undefined;
    message.userId = object.userId ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.stage = object.stage ?? "";
    message.actionDescription = object.actionDescription ?? "";
    message.agentName = object.agentName ?? "";
    message.extra = (globalThis.Object.entries(object.extra ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.system = object.system ?? false;
    message.featureId = object.featureId ?? undefined;
    return message;
  },
};

function createBaseWorkLogItem_ExtraEntry(): WorkLogItem_ExtraEntry {
  return { key: "", value: "" };
}

export const WorkLogItem_ExtraEntry: MessageFns<WorkLogItem_ExtraEntry> = {
  encode(message: WorkLogItem_ExtraEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkLogItem_ExtraEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkLogItem_ExtraEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkLogItem_ExtraEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: WorkLogItem_ExtraEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<WorkLogItem_ExtraEntry>): WorkLogItem_ExtraEntry {
    return WorkLogItem_ExtraEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WorkLogItem_ExtraEntry>): WorkLogItem_ExtraEntry {
    const message = createBaseWorkLogItem_ExtraEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
